import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/auth/Login';
import Register from './pages/auth/Register';
import CampaignList from './pages/campaign/CampaignList';
import CampaignCreate from './pages/campaign/CampaignCreate';
import CampaignEdit from './pages/campaign/CampaignEdit';
import SectionEdit from './pages/campaign/SectionEdit';
import CampaignEntries from './pages/campaign/CampaignEntries';
import CampaignPublic from './pages/campaign/public/CampaignPublic';
import WinnerPage from './pages/campaign/public/WinnerPage';
import IndemnityFormPublic from './pages/indemnity-landing-page/public/IndemnityFormPublic';
import Products from './pages/products/Products';
import Templates from './pages/templates/Templates';
import TemplateEdit from './pages/templates/TemplateEdit';
import Users from './pages/user-management/Users';
import Forms from './pages/forms/Forms';
import FormEdit from './pages/forms/FormEdit';
import Reports from './pages/reports/Reports';
import NewsletterSubscribersReport from './pages/reports/NewsletterSubscribersReport';
import CampaignReports from './pages/campaign/CampaignReports';
import MechanicsList from './pages/mechanics/MechanicsList';
import MechanicsEdit from './pages/mechanics/MechanicsEdit';
import ContactMessages from './pages/contact/ContactMessages';
import TcnGiftCardProfiles from './pages/tcn/TcnGiftCardProfiles';
import TestReceipt from './pages/test/TestReceipt';
import IndemnityFormSubmissions from './pages/indemnity-landing-page/IndemnityFormSubmissions';
import MembershipList from './pages/membership/MembershipList';
import IndemnityLandingPages from './pages/indemnity-landing-page/IndemnityLandingPages';
import IndemnityLandingPageEdit from './pages/indemnity-landing-page/IndemnityLandingPageEdit';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import { authService } from './services/authService';
import PrizeEdit from './pages/campaign/instant-win/PrizeEdit';
import ManageClaimCodesPage from './pages/campaign/instant-win/ManageClaimCodes';
import './App.css';

function App() {
  const isBrowser = typeof window !== 'undefined';
  
  // Custom domain detection - admin domains show login, custom domains show campaigns
  const isCustomDomain = isBrowser ? 
    !window.location.hostname.includes('gooddrinkspromotion.dailypress.com.au') && 
    !window.location.hostname.includes('localhost') && 
    !window.location.hostname.includes('127.0.0.1') : false;

  return (
    <Router>
      <div className="App">
        <Routes>
          {isCustomDomain ? (
            <>
              <Route path="/" element={<CampaignPublic />} />
              <Route path="/winner" element={<WinnerPage />} />
              <Route path="/campaign/:slug" element={<CampaignPublic />} />
              <Route path="/campaign/:slug/winner" element={<WinnerPage />} />
              <Route path="/campaign/:slug/indemnity-form" element={<IndemnityFormPublic />} />
              <Route path="/:slug/indemnity-form" element={<IndemnityFormPublic />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </>
          ) : (
            <>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route
                path="/test-receipt"
                element={
                  <AdminRoute>
                    <TestReceipt />
                  </AdminRoute>
                }
              />
              <Route path="/campaign/:slug" element={<CampaignPublic />} />
              <Route path="/campaign/:slug/winner" element={<WinnerPage />} />
              <Route path="/campaign/:slug/indemnity-form" element={<IndemnityFormPublic />} />
              <Route path="/:slug/indemnity-form" element={<IndemnityFormPublic />} />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <Navigate to="/admin/campaigns" />
                  </PrivateRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <AdminRoute>
                    <Navigate to="/admin/campaigns" />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/campaigns"
                element={
                  <AdminRoute>
                    <CampaignList />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/campaigns/new"
                element={
                  <AdminRoute>
                    <CampaignCreate />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/campaigns/:id/edit"
                element={
                  <AdminRoute>
                    <CampaignEdit />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/campaigns/:campaignId/sections/:sectionId/edit"
                element={
                  <AdminRoute>
                    <SectionEdit />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/campaigns/:campaignId/instant-win/prizes/:prizeId/edit"
                element={
                  <AdminRoute>
                    <PrizeEdit />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/campaigns/:campaignId/instant-win/prizes/:prizeId/claim-codes"
                element={
                  <AdminRoute>
                    <ManageClaimCodesPage />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/campaigns/:id/entries"
                element={
                  <AdminRoute>
                    <CampaignEntries />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/mechanics"
                element={
                  <AdminRoute>
                    <MechanicsList />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/mechanics/:id/edit"
                element={
                  <AdminRoute>
                    <MechanicsEdit />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/products"
                element={
                  <AdminRoute>
                    <Products />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/templates"
                element={
                  <AdminRoute>
                    <Templates />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/templates/:id/edit"
                element={
                  <AdminRoute>
                    <TemplateEdit />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/users"
                element={
                  <AdminRoute>
                    <Users />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/contact-messages"
                element={
                  <AdminRoute>
                    <ContactMessages />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/tcn-profiles"
                element={
                  <AdminRoute>
                    <TcnGiftCardProfiles />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/indemnity-submissions"
                element={
                  <AdminRoute>
                    <IndemnityFormSubmissions />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/membership"
                element={
                  <AdminRoute>
                    <MembershipList />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/indemnity-landing-pages"
                element={
                  <AdminRoute>
                    <IndemnityLandingPages />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/indemnity-landing-pages/:id/edit"
                element={
                  <AdminRoute>
                    <IndemnityLandingPageEdit />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/forms"
                element={
                  <AdminRoute>
                    <Forms />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/forms/:id/edit"
                element={
                  <AdminRoute>
                    <FormEdit />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/reports"
                element={
                  <AdminRoute>
                    <Reports />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/reports/campaigns"
                element={
                  <AdminRoute>
                    <CampaignReports />
                  </AdminRoute>
                }
              />
              <Route
                path="/admin/reports/newsletter"
                element={
                  <AdminRoute>
                    <NewsletterSubscribersReport />
                  </AdminRoute>
                }
              />
              <Route
                path="/"
                element={
                  authService.isAuthenticated() ? (
                    <Navigate to="/admin/campaigns" />
                  ) : (
                    <Navigate to="/login" />
                  )
                }
              />
            </>
          )}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
